import { style } from '@vanilla-extract/css';

export const contactForm = style({
  padding: 'var(--padding)',

  '@media': {
    'only screen and (--mobile)': {
      padding: 'var(--mobile-padding)',
    },
  },
});

export const titleStyle = style({
  color: 'var(--title-color)',
  fontFamily: 'var(--title-font-family)',
});

export const descriptionStyle = style({
  color: 'var(--description-color)',
  fontFamily: 'var(--description-font-family)',
});
